module.exports = __webpack_public_path__ + "static/media/lupa.44fb8bb3.svg";